import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Typography, Tabs, Tab } from '@mui/material';
import SPDInfo from './SPDInfo';
import SPDLeadership from './SPDLeadership';
import SPDCommittees from './SPDCommittees';
import SPDGroupsReciprocities from '../Reciprocities/SPDGroupsRecipro';
import SPDResources from './SPDResources';
import { useApiGet } from '../../../utils/httpClientTs';
import { getSpdDetail } from '../../../endpoints/chaptersTs';

interface SPDDetailData {
  name: string;
  spd_access: boolean;
}

const SPDDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [tabSelected, setTabSelected] = useState<number>(0);

  const { data } = useApiGet<SPDDetailData>(
    ['spd-chapters-detail', id],
    getSpdDetail,
    {
      enabled: true,
      retry: 1,
    },
    {
      id: id || '',
    }
  );

  return (
    <Grid container>
      <Grid item xs={12} sx={{ padding: 2, textAlign: 'center' }}>
        <Typography variant="h4">{data?.name}</Typography>
      </Grid>
      <Grid item xs={12} sx={{ padding: 2 }}>
        <Tabs
          value={tabSelected}
          onChange={(event, newValue) => setTabSelected(newValue)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Chapter Info" />
          <Tab label="Chapter Leadership" />
          <Tab label="Chapter Committees" />
          <Tab label="Groups and Reciprocities" />
          {data?.spd_access && <Tab label="Resources" />}
        </Tabs>
      </Grid>
      <Grid item xs={12} sx={{ padding: 2 }}>
        {tabSelected === 0 && (
          <SPDInfo id={id || ''} spdAccess={data?.spd_access || false} />
        )}
        {tabSelected === 1 && (
          <SPDLeadership id={id || ''} spdAccess={data?.spd_access || false} />
        )}
        {tabSelected === 2 && (
          <SPDCommittees id={id || ''} spdAccess={data?.spd_access || false} />
        )}
        {tabSelected === 3 && <SPDGroupsReciprocities id={id || ''} />}
        {data?.spd_access && tabSelected === 4 && <SPDResources />}
      </Grid>
    </Grid>
  );
};

export default SPDDetail;
